module.exports = __webpack_public_path__ + "static/media/rw.0afcd745.png";